// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__28zp1","inner":"Footer_inner__1VSAY","nextIcon":"Footer_nextIcon__1Sdyb","innerLeft":"Footer_innerLeft__sLDfW"};